// @ts-nocheck

import PropTypes from 'prop-types'
import React from 'react'

import { LogSummary } from '../../LogSummary'

export default function LogCell(props) {
  const {
    log,
    log: { deleted },
    onSelect,
    role,
    style
  } = props

  return (
    <LogSummary
      data={log}
      isLogRemoved={deleted}
      linkEnabled={role === 'carehome-admin'}
      logStyle={{ ...styles.log, ...style }}
      onSelect={onSelect}
    />
  )
}

const styles = {
  log: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    lineHeight: 1.4
  }
}

LogCell.propTypes = {
  log: PropTypes.object.isRequired,
  onSelect: PropTypes.func,
  role: PropTypes.string,
  style: PropTypes.object
}
